export function registerGTMEvent(data: Record<string, any>) {
  if (typeof window !== undefined && window?.dataLayer) {
    window?.dataLayer?.push({
      ...data,
    });
  }
}
